<div class="qira-search">
  <mat-icon class="qira-search__icon" aria-hidden="true">search</mat-icon>
  <input class="qira-search__input"
         type="text"
         placeholder="Search residents…"
         [formControl]="searchControl"
         [matAutocomplete]="auto"
         aria-label="Global search" />
  <button *ngIf="searchControl.value"
          type="button"
          class="qira-search__clear"
          (click)="searchControl.setValue('')"
          aria-label="Clear search">
    <mat-icon>close</mat-icon>
  </button>

  <mat-autocomplete #auto="matAutocomplete" [displayWith]="getDisplayName" class="qira-search__panel">
    <ng-container *ngIf="resultGroups.length; else noResults">
      <mat-optgroup *ngFor="let group of resultGroups" [label]="group.label + ' (' + group.items.length + ')'">
        <mat-option *ngFor="let item of group.items"
                    [value]="item"
                    (onSelectionChange)="onItemSelected(item, group.label, $event)">
          <span class="qira-search__result">{{ getDisplayName(item) }}</span>
        </mat-option>
      </mat-optgroup>
    </ng-container>
    <ng-template #noResults>
      <mat-option disabled *ngIf="showNoResults">
        <span class="qira-search__empty">No residents found</span>
      </mat-option>
    </ng-template>
  </mat-autocomplete>
</div>
